/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for OrganizationApi services
 */
@Injectable({
  providedIn: 'root',
})
export class OrganizationApiConfiguration {
  rootUrl: string = '';
}

export interface OrganizationApiConfigurationInterface {
  rootUrl?: string;
}
